import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators, FormArray} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../../services/global.service';

@Component({
  selector: 'app-adjust-long-term-care-cost',
  templateUrl: './ltc-adjust-cost.component.html',
  styleUrls: ['./ltc-adjust-cost.component.css']
})
export class AdjustLongTermCareCost implements OnInit, AfterViewChecked {
  //used for auto scrolling the care settings for client and spouse
  @ViewChild('clientScroll') private clientScrollContainer: ElementRef;
  @ViewChild('spouseScroll') private spouseScrollContainer: ElementRef;
  clientScrollAtBottom: boolean = true;
  spouseScrollAtBottom: boolean = true;

  //dynamic care settings forms for client and spouse
  //standardProjection: FormGroup;
  buildCareProjection: FormGroup;
  careSettings = this.fb.group({
    client: this.fb.array([]),
    spouse: this.fb.array([]),
    selectedTab: 1
  });
  standardProjection = this.fb.group({
    client: this.fb.array([]),
    spouse: this.fb.array([]),
    selectedTab: 1
  });
  clientFirstCareSetting: boolean = true;
  spouseFirstCareSetting: boolean = true;

  //for dropdowns
  careType =[];
  spouseCareType = [];
  // careType1 =[
  //   { name: "Assisted Living", value: 1 },
  //   { name: "Nursing Home", value: 0 },
  //   { name: "Informal Care", value: 3 },
  //   //{ name: "Blended Average", value: 4 }    
  // ];
  //needs to be programmatically set do a few things
  // - MAX allowed is 15yrs
  // - if the difference between client/spouse current age and LE is less than 15yrs, make that value the MAX allowed
  // - removing and refactoring the years with previously set years in the array for the client/spouse
  clientLengthYears = 0;
  spouseLengthYears = 0;
  clientYearsUntilLE = 0;
  clientYearsAlreadyInLTC = 0;
  spouseYearsAlreadyInLTC = 0;
  spouseYearsUntilLE = 0;
  clientLengthOfCare = [];
  spouseLengthOfCare = [];
  selectedTab = 1;
  //object from parent page about the client profile
  data;

  //HACK: this should all come from the 'data' not done in this component
  client;
  partnerActive: boolean = false;

  error;

  constructor(public globalService: GlobalService, private fb: FormBuilder, public dialogRef: MatDialogRef<AdjustLongTermCareCost>,
    @Inject(MAT_DIALOG_DATA) data) {
      console.log('data passed', data);
      this.data = data;
      
      //set length of care with data from parent 
      this.getClient();
     }

  ngOnInit() {
    this.assignValuesToCareTypeDD();
    // this.careType.push([
    //   { name: "Home Health Care", value: 2 },
    //   { name: "Assisted Living", value: 1 },
    //   { name: "Nursing Home", value: 0 },
    //   { name: "Informal Care", value: 3 },
    //   //{ name: "Blended Average", value: 4 }    
    // ]);
    
    // this.spouseCareType.push([
    //   { name: "Home Health Care", value: 2 },
    //   { name: "Assisted Living", value: 1 },
    //   { name: "Nursing Home", value: 0 },
    //   { name: "Informal Care", value: 3 },
    //   //{ name: "Blended Average", value: 4 }    
    // ]);
    //auto load values for first time
    /* this.clientControl.push(
      this.fb.group({
        careType: new FormControl('', [Validators.required]),
        lengthOfCare: new FormControl('', [Validators.required]),
      })
    ); */

    if(this.data.clientObject.selectedTab){
      this.selectedTab = this.data.clientObject.selectedTab;
    }

    for(var i = 0; i < this.data.clientObject.ClientCareTypes.length; i++){
      this.clientControl.push(
        this.fb.group({
          careType: new FormControl(this.data.clientObject.ClientCareTypes[i].careType, [Validators.required]),
          lengthOfCare: new FormControl(this.data.clientObject.ClientCareTypes[i].lengthOfCare, [Validators.required]),
        })
      );

      if(this.data.clientObject.ClientCareTypes.length > 1){
        this.clientFirstCareSetting = false;
      }

      if(this.data.clientObject.SpouseCareTypes.length > 1){
        this.spouseFirstCareSetting = false;
      }
    }

    /* this.spouseControl.push(
      this.fb.group({
        careType: new FormControl('', [Validators.required]),
        lengthOfCare: new FormControl('', [Validators.required]),
      })
    ); */

    this.standardClientControl.push(this.fb.group({
      careType: new FormControl(this.data.clientObject.CareType),
      lengthOfCare: new FormControl(this.data.clientObject.FrmLTCMonths0),
    }));
    
    /* this.standardSpouseControl.push(this.fb.group({
      careType: new FormControl(1),
      lengthOfCare: new FormControl(''),
    })); */
    
  }

  assignValuesToCareTypeDD() {
    if (this.data) {
      var careType = this.data.clientObject.ClientCareTypes[0].careType;
      this.careType.push([
        { name: "Home Healthcare", value: 2 },
        { name: "Assisted Living", value: 1 },
        { name: "Nursing Home", value: 0 },
        { name: "Informal Care", value: 3 }, 
      ]);
      for(var i = 1; i < this.data.clientObject.ClientCareTypes.length; i++){
        this.careType.push([
          { name: "Home Healthcare", value: 2 },
          { name: "Assisted Living", value: 1 },
          { name: "Nursing Home", value: 0 },
          { name: "Informal Care", value: 3 }, 
        ]);
        this.careType[i] = this.careType[i - 1].filter(item => item.value != careType);
        careType = this.data.clientObject.ClientCareTypes[i].careType;
      }
    } else {
      this.careType.push([
        { name: "Home Healthcare", value: 2 },
        { name: "Assisted Living", value: 1 },
        { name: "Nursing Home", value: 0 },
        { name: "Informal Care", value: 3 },    
      ]);
    }

  }

  ngAfterViewChecked() {       
    if(!this.clientScrollAtBottom || !this.spouseScrollAtBottom) {
      this.scrollToBottom((!this.clientScrollAtBottom) ? true : false);
    }        
  }

  LTCExpensesData;
  LTCExpensesDataClientSelected;
  LTCExpensesDataSpouseSelected;
  getLTCExpenses(){
    //HACK: this 'body' should be an object in a service; NOT dynamically built in a string
    let body = { };
    if(this.partnerActive){

      //set the form for Spouse here as well
      /* this.spouseControl.push(
        this.fb.group({
          careType: new FormControl('', [Validators.required]),
          lengthOfCare: new FormControl('', [Validators.required]),
        })
      ); */
      if (this.data) {
        var spouseCareType = this.data.clientObject.SpouseCareTypes[0].careType;
        this.spouseCareType.push([
          { name: "Home Healthcare", value: 2 },
          { name: "Assisted Living", value: 1 },
          { name: "Nursing Home", value: 0 },
          { name: "Informal Care", value: 3 }, 
        ]);
        for(var i = 1; i < this.data.clientObject.SpouseCareTypes.length; i++){
          this.spouseCareType.push([
            { name: "Home Healthcare", value: 2 },
            { name: "Assisted Living", value: 1 },
            { name: "Nursing Home", value: 0 },
            { name: "Informal Care", value: 3 }, 
          ]);
          this.spouseCareType[i] = this.spouseCareType[i - 1].filter(item => item.value != spouseCareType);
          spouseCareType = this.data.clientObject.SpouseCareTypes[i].careType;
        }
      } else {
        this.spouseCareType.push([
          { name: "Home Healthcare", value: 2 },
          { name: "Assisted Living", value: 1 },
          { name: "Nursing Home", value: 0 },
          { name: "Informal Care", value: 3 },    
        ]);
      }
      for(var i = 0; i < this.data.clientObject.SpouseCareTypes.length; i++){
        this.spouseControl.push(
          this.fb.group({
            careType: new FormControl(this.data.clientObject.SpouseCareTypes[i].careType, [Validators.required]),
            lengthOfCare: new FormControl(this.data.clientObject.SpouseCareTypes[i].lengthOfCare, [Validators.required]),
          })
        );
      }

      /* this.standardSpouseControl.push(this.fb.group({
        careType: new FormControl(1),
        lengthOfCare: new FormControl(''),
      })); */

      this.standardSpouseControl.push(this.fb.group({
        careType: new FormControl(this.data.clientObject.CareType1),
        lengthOfCare: new FormControl(this.data.clientObject.FrmLTCMonths1),
      }));

      //set body for request
      body = {
          retirementState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
          People:[
            {
              lifeExpectencyAge: this.client.clientProfile.LifeExpectancy,
              DateOfBirth: this.client.client.DOB,
              Gender: this.client.client.GenderID,
              conditions: [0],
              //default these??
              //numberOfNursingCareLTCYears: 1,
              //numberOfAssistedCareLTCYears: 2,
              //numberOfHomeCareLTCYears: 1
            },
            {
              lifeExpectencyAge: this.client.clientProfile.Spouses[0].LifeExpectancy,
              DateOfBirth: this.client.clientProfile.Spouses[0].dob,
              Gender: Number(this.client.clientProfile.Spouses[0].gender),
              conditions: [0],
              //default these??
              //numberOfNursingCareLTCYears: 1,
              //numberOfAssistedCareLTCYears: 2,
              //numberOfHomeCareLTCYears: 1
            }            
          ]
      };
    } else{
      body = {
        retirementState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
        People:[
          {
            lifeExpectencyAge: this.client.clientProfile.LifeExpectancy,
            DateOfBirth: this.client.client.DOB,
            Gender: this.client.client.GenderID,
            conditions: [0],
            //default these??
            //numberOfNursingCareLTCYears: 1,
            //numberOfAssistedCareLTCYears: 2,
            //numberOfHomeCareLTCYears: 1
          }           
        ]
     };
    }

    this.globalService.getLTCDataVx(body)
      .subscribe(
      data => {
        //store these expenses for later
        this.LTCExpensesData = data;
        console.log('LTC Expenses', data);

        //apply to form: standardProjection
        //default value should be estimated ALOS for given life expectancy (rounded to the nearest month)
        for(var i in data.ALF){
          //console.log('data in LTC Expenses', i);
          //client
          if(data.ALF[i].age == this.client.clientProfile.LifeExpectancy){
            if (!this.data.clientObject.isReturenedAdjustedData) {
              //set the year, ALOS and costs
              this.LTCExpensesDataClientSelected = data.ALF[i];
              //convert ALOS to yr and months
              var selectThisOption = this.yearsToYearsMonths(data.ALF[i].averageLengthOfStay);
              //console.log('standardClientControl', selectThisOption);
              //this.standardClientControl.patchValue([{ lengthOfCare: selectThisOption }]);
            }

            
            this.getLTCData(this.client);
            
            break;
          }
        }

      });
  }

  ltcResponse;
  getLTCData(client) {
    
    //need to path the LTC object with latest values from 
    //this.standardClientControl.patchValue([{ lengthOfCare: selectThisOption }]);
    console.log('client', client);
    console.log('this.standardProjection.value.client[0]', this.standardProjection.value.client[0])
    console.log('this.careSettings.value.client', this.careSettings.value.client)
    this.data.clientObject.CareType = this.standardProjection.value.client[0].careType;
    this.data.clientObject.FrmLTCMonths0 = this.standardProjection.value.client[0].lengthOfCare;
    // this.data.clientObject.ClientCareTypes[0].careType = this.standardProjection.value.client[0].careType;
    // this.data.clientObject.ClientCareTypes[0].lengthOfCare = this.standardProjection.value.client[0].lengthOfCare;

    if(this.partnerActive){
      this.data.clientObject.CareType1 = this.standardProjection.value.spouse[0].careType;
      this.data.clientObject.FrmLTCMonths1 = this.standardProjection.value.spouse[0].lengthOfCare;
      // this.data.clientObject.SpouseCareTypes[0].careType = this.standardProjection.value.spouse[0].careType;
      // this.data.clientObject.SpouseCareTypes[0].lengthOfCare = this.standardProjection.value.spouse[0].lengthOfCare;
    }

    //added for Build Care
    this.data.clientObject.ClientCareTypes = this.careSettings.value.client;//this.selfTypeList;
    this.data.clientObject.SpouseCareTypes = this.careSettings.value.spouse;//this.spouseTypeList;
    const isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    const queryInfo = {
      clientID: client.client.ID,
      userID: client.client.AdvisorID,
      orgID: client.client.OrganizationID,
      clientRetirementAge: client.clientProfile.RetirementAge,
      partnerRetirementAge: isMarried ? this.client.clientProfile.Spouses[0].retirementAge : 0
    }

    this.data.clientObject.SelfDOB = this.client.client.DOB;
    this.data.clientObject.SpouseDOB = this.partnerActive ? this.client.clientProfile.Spouses[0].dob : "";

 console.log('this.data.clientObject', this.data.clientObject)
 console.log('queryInfo', queryInfo);
    this.globalService.getLTCData(this.data.clientObject, queryInfo)
      .subscribe(
        data => {
          this.ltcResponse = data;
          console.log('this.ltcResponse', this.ltcResponse)

        },
        error => this.error = <any>error);  
  }

  ltcBuildCostResponse;
  getBuildCostLTCData(isClient){
    //TODO: make a call like getLTCData, but allow for multiple Care Types and Length Of Stays
    //this.ltcBuildCostResponse = 
  }

  yearsToYearsMonths(value)
  {
      var totalDays = value * 365;
      var years = Math.floor(totalDays/365);
      var months = Math.floor((totalDays-(years *365))/30);
      //var days = Math.floor(totalDays - (years*365) - (months * 30));
      //var result = years + " years, " + months + " months, " + days + " days";
      if(years > 0){
        months += years * 12;
      }

      return months;
  }

  //HACK: this functionality should probably be removed and passed to this component from the parent
  //TODO: remove and have the client info passed into this
  getClient() {
    console.log('get Client data');
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
      client => {
        console.log(client);

        //setup the client
        this.client = client;       
        this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);

        this.clientYearsUntilLE = this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB);
        this.clientLengthYears = Math.min(15, this.clientYearsUntilLE);
        console.log('client length', this.clientLengthYears);
        var months = 0;
        var year = 0;//(i < 12) ? 0 :           
        for(var i = 1; i <= (this.clientLengthYears * 12); i++){
          
          months++;
          if(months == 12){
            months = 0;
            year += 1;
          }

          this.clientLengthOfCare.push({ name: (year > 0) ? (year + ((year > 1) ? " years" : " year") + ((months > 0) ? ", " + months + ((months > 1) ? " months" : " month") : "")) : months + ((months > 1) ? " months" : " month"), value: i });
        }
                
        //setup spouse if spouse
        if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {

          this.spouseYearsUntilLE = this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob);
          this.spouseLengthYears = Math.min(15, this.spouseYearsUntilLE);
          var months = 0;
          var year = 0;//(i < 12) ? 0 :           
          for(var i = 1; i <= (this.spouseLengthYears * 12); i++){
            
            months++;
            if(months == 12){
              months = 0;
              year += 1;
            }

            this.spouseLengthOfCare.push({ name: (year > 0) ? (year + ((year > 1) ? " years" : " year") + ((months > 0) ? ", " + months + ((months > 1) ? " months" : " month") : "")) : months + ((months > 1) ? " months" : " month"), value: i });
          }

          this.partnerActive = true;

        } else {
          this.partnerActive = false;
        }

        //get LTC Expenses after Client data loads
        this.getLTCExpenses();
        //this.getLTCData(client);

      });
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  clientMessageYearsMonthsOver;
  changeClientLengthOfCare(index, value){
    //get new values
    this.changeBuildLengthOfCare(value, true);

    //recalc dropdown for client
    this.clientRecalcLengthOfCare();
  }

  changeStandardLengthOfCare(value, isClient){
    //need to figure out the value to get matched in the array stored for each section
    console.log('triggered from open', value);
    if (isClient) {
      this.standardProjection.value.client[0].lengthOfCare = value;
    } else {
      this.data.clientObject.SpouseCareTypes[0].lengthOfCare = this.standardProjection.value.spouse[0].lengthOfCare;
    }
    this.getLTCData(this.client);
  }

  changeStandardCareSetting(value, isClient){
    //every change of care setting, we need reset the costs/values/year

    this.getLTCData(this.client);
  }

  changeBuildLengthOfCare(value, isClient){
    //TODO: need to have another endpoint (or modify the existing one) to allow multiple Length of Care values
    //this.getBuildCostLTCData(isClient);
    this.getLTCData(this.client);
  }

  changeBuildCareSetting(value, isClient){
    //TODO: need to have another endpoint (or modify the existing one) to allow multiple Care Setting values
    //this.getBuildCostLTCData(isClient);
    // if (isClient) {
    //   this.standardProjection.value.client[0].lengthOfCare = value;
    // } else {
    //   this.data.clientObject.SpouseCareTypes[0].lengthOfCare = this.standardProjection.value.spouse[0].lengthOfCare;
    // }
    this.getLTCData(this.client);
  }

  clientRecalcLengthOfCare(){
    var total = 0;
    for(let t in this.clientControl.value){
      total += parseInt(this.careSettings.value.client[t].lengthOfCare);
    }
    console.log('changed again', total);
    this.clientYearsAlreadyInLTC = total;

    //now do check on if you can add anymore
    if((this.clientYearsUntilLE * 12) <= total){
      //display the LE message with the amount left over
     //X years and Y months
      var monthsUntilLE = this.clientYearsUntilLE * 12;
      var monthsOver = total - monthsUntilLE;
      console.log('months over', monthsOver);

      var months = 0;
      var year = 0;//(i < 12) ? 0 :           
      for(var i = 1; i <= monthsOver; i++){          
        months++;
        if(months == 12){
          months = 0;
          year += 1;
        }        
      }

      this.clientMessageYearsMonthsOver = ((year > 0) ? year + ((year > 1) ? " years" : " year") + " and " : "") + ((months > 0) ? months + ((months > 1) ? " months" : " month") : "");
    }
  }

  spouseMessageYearsMonthsOver;
  changeSpouseLengthOfCare(index, value){
    //get new values
    this.changeBuildLengthOfCare(value, false);

    //recalc spouse dropdown
    this.spouseRecalcLengthOfCare();
  }

  spouseRecalcLengthOfCare(){
    var total = 0;
    for(let t in this.spouseControl.value){
      total += parseInt(this.careSettings.value.spouse[t].lengthOfCare);
    }
    console.log('changed again', total);
    this.spouseYearsAlreadyInLTC = total;

    //now do check on if you can add anymore
    if((this.spouseYearsUntilLE * 12) <= total){
      //display the LE message with the amount left over
     //X years and Y months
      var monthsUntilLE = this.spouseYearsUntilLE * 12;
      var monthsOver = total - monthsUntilLE;
      console.log('months over', monthsOver);

      var months = 0;
      var year = 0;//(i < 12) ? 0 :           
      for(var i = 1; i <= monthsOver; i++){          
        months++;
        if(months == 12){
          months = 0;
          year += 1;
        }        
      }

      this.spouseMessageYearsMonthsOver = ((year > 0) ? year + ((year > 1) ? " years" : " year") + " and " : "") + ((months > 0) ? months + ((months > 1) ? " months" : " month") : "");
    }
  }

  close(update): void {
    if(update){
      //if selected tab is 1, this is the basic form, else is the dynamic form
      console.log('this.standardProjection', this.standardProjection)
      if(this.selectedTab > 1){     
        console.log('this.careSettings.value', this.careSettings.value);
        this.careSettings.controls['selectedTab'].setValue(this.selectedTab);
        this.dialogRef.close(this.careSettings.value);
      } else {
        this.standardProjection.controls['selectedTab'].setValue(this.selectedTab);
        this.dialogRef.close(this.standardProjection.value);
      }
    } else {
      this.dialogRef.close();
    }
  }

  selectedTabChange(event){
    //console.log('selected tab', event);
    this.selectedTab = event.index;
  }

  get clientControl(): FormArray {
    return this.careSettings.get("client") as FormArray;
  }

  get spouseControl(): FormArray {
    return this.careSettings.get("spouse") as FormArray;
  }

  get standardClientControl(): FormArray {
    return this.standardProjection.get("client") as FormArray;
  }

  get standardSpouseControl(): FormArray {
    return this.standardProjection.get("spouse") as FormArray;
  }

  add(client, dontAllow) {

    if(dontAllow){
      return;
    }

    if(client){
      this.clientControl.push(
        this.fb.group({
          careType: new FormControl('', [Validators.required]),
          lengthOfCare: new FormControl('', [Validators.required]),
        })
      );

      //figure out the differnce of years for length of care
      //this.clientLengthOfCare
      //console.log('test', this.careSettings.value.client.reduce((n, { lengthOfCare }) => n + lengthOfCare, 0));
      //console.log('test', this.careSettings.value.client.map(item => item.lengthOfCare).reduce((prev, curr) => prev + curr, 0));
      //this.clientYearsAlreadyInLTC += 1;
      this.clientScrollAtBottom = false;
      this.clientFirstCareSetting = false;
      console.log('this.clientControl', this.clientControl.length);
      this.careType.push([
        { name: "Home Healthcare", value: 2 },
        { name: "Assisted Living", value: 1 },
        { name: "Nursing Home", value: 0 },
        { name: "Informal Care", value: 3 },
        //{ name: "Blended Average", value: 4 }    
      ]);
      let careTypeVal = 0;
      this.clientControl.controls.forEach((clientControl) => {
        console.log('clientControl', clientControl.value.careType);
        let clientCareType = clientControl.value.careType || null;
     
        if (clientCareType == null) {
          console.log('no value');
          this.careType[this.clientControl.length - 1] = this.careType[this.clientControl.length - 2].filter(item => item.value != careTypeVal);
        } else {
          careTypeVal = clientControl.value.careType;
          console.log('val1', careTypeVal)
        }

        // if (clientControl.value.careType > 0) {
        //   // let val = this.clientControl.controls[0].value.careType;
        //   let val = clientControl.value.careType;
        //   console.log('clientControl1', clientControl.value.careType);
        //   console.log('clientControl2', this.clientControl.controls[0].value.careType);
        //   console.log('here i am ')
        //   for (let i = 0; i < this.clientControl.length; i++) {
        //     // let val = this.clientControl.controls[i].value.careType;
        //     console.log('clientControl3', clientControl.value.careType);
        //     this.careType[this.clientControl.length - 1] = this.careType[i].filter(item => item.value != val);
        //     // val = this.clientControl.controls[i].value.careType;
        //   }
        // }

       

      });

    } else {
      this.spouseControl.push(
        this.fb.group({
          careType: new FormControl('', [Validators.required]),
          lengthOfCare: new FormControl('', [Validators.required]),
        })
      );      

      //figure out the differnce of years for length of care
      //this.spouseLengthOfCare
      //this.spouseYearsAlreadyInLTC += 1;
      this.spouseScrollAtBottom = false;
      this.spouseFirstCareSetting = false;
      console.log('this.clientControl', this.spouseControl.length);
      this.spouseCareType.push([
        { name: "Home Healthcare", value: 2 },
        { name: "Assisted Living", value: 1 },
        { name: "Nursing Home", value: 0 },
        { name: "Informal Care", value: 3 },
        //{ name: "Blended Average", value: 4 }    
      ]);
      let spouseCareTypeVal = 0;
      this.spouseControl.controls.forEach((spouseControl) => {
        console.log('clientControl', spouseControl.value.careType);
        let spouseCareType = spouseControl.value.careType || null;
     
        if (spouseCareType == null) {
          console.log('no value');
          this.spouseCareType[this.spouseControl.length - 1] = this.spouseCareType[this.spouseControl.length - 2].filter(item => item.value != spouseCareTypeVal);
        } else {
          spouseCareTypeVal = spouseControl.value.careType;
          console.log('val1', spouseCareTypeVal)
        }

       

      });
      
    }

    console.log('added', this.careSettings.value.client);
  }

  remove(index, client) {
    if(client){
      //this.clientYearsAlreadyInLTC -= 1;
      this.clientControl.removeAt(index);
      this.clientRecalcLengthOfCare();
      if(this.careSettings.value.client.length == 0){
        this.clientControl.push(
          this.fb.group({
            careType: new FormControl('', [Validators.required]),
            lengthOfCare: new FormControl('', [Validators.required]),
          })
        );
        this.clientFirstCareSetting = true;
      } 
    } else {
      //this.spouseYearsAlreadyInLTC -= 1;
      this.spouseControl.removeAt(index);
      if(this.careSettings.value.spouse.length == 0){
        this.spouseControl.push(
          this.fb.group({
            careType: new FormControl('', [Validators.required]),
            lengthOfCare: new FormControl('', [Validators.required]),
          })
        );    
        this.spouseFirstCareSetting = true;    
      }

      this.careSettings.updateValueAndValidity();
    }

    console.log('removed', this.careSettings.value.client);
  }

  //NOTE: how would this even work? The UI shows this as a drag and drop thing....is this necessary??
  swap(index, client){
    //TODO: was told not important for day one

  }

  scrollToBottom(client) {
    if(client){
      this.clientScrollContainer.nativeElement.scrollTop = this.clientScrollContainer.nativeElement.scrollHeight;
      this.clientScrollAtBottom = true;
    } else{
      this.spouseScrollContainer.nativeElement.scrollTop = this.spouseScrollContainer.nativeElement.scrollHeight;
      this.spouseScrollAtBottom = true;
    }
  }

}
